import { AxiosRequestHeaders, AxiosResponse } from "axios";
import { GetCurrentLogin } from "../account/AccountStore";

import axios from "../general/HttpClient";

//@ts-ignore
const identityURL = identityServer;

const COVID_APP_TYPE = 5;

export function GetUserInfo() {
    return axios.get(`${identityURL}connect/userinfo`);
}

export function GetMyApplications(user) {
    let headers = { "x-sca-ide-org-context": user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/Applications/GetMyApplications`, { params: { type: COVID_APP_TYPE }, headers });
}

export function ResolveUsers(users) {
    return axios.post(`${identityURL}api/Users/$resolve`, { users }).then((response) => {
        return response.data;
    });
}

export function SearchUsers(organizationID, query) {
    let headers = { "x-sca-ide-org-context": organizationID };

    return axios.get(`${identityURL}api/Users/searchUsers`, { params: { query }, headers }).then((response: AxiosResponse<IdentityUser[]>) => {
        return response.data;
    });
}

export function GetIdentityGroups(organizationId) {
    return axios.get(`${identityURL}api/Groups/${organizationId}`).then((response) => {
        return response.data;
    });
}

export function GetIdentityGroupMembers(groupId) {
    return axios.get(`${identityURL}api/Groups/${groupId}/members`).then((response) => {
        return response.data;
    });
}

export function GetOrganizations() {
    return axios.get(`${identityURL}api/Organizations/`).then((response) => {
        return response.data;
    });
}

export async function GetOrganization(organizationId) {
    let user = await GetCurrentLogin();

    let headers = { "x-sca-ide-org-context": user.getClaim("sca-organization") } as any;

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/Organizations/${organizationId}`, { headers }).then((response) => {
        return response.data;
    });
}

export interface GetIdentityOrganizationMembersResponse {
    members: IdentityUser[];
    total: number;
}

export interface IdentityUser {
    organization: string;
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    photo: string;
    lastLoginDate: string;
    fullName: string;
    displayName: string;
    hasGivenAccessTo: DelegatedAccess[];
    hasAccessOn: DelegatedAccess[];
    groups: IdentityGroup[];
    sourceIdentifiers: SourceIdentifier[];
}

export interface DelegatedAccess {
    delegatorID: string;
    delegateeID: string;
    delegationRules: string;
    delegatee: IdentityUser;
    delegator: IdentityUser;
}

export interface SourceIdentifier {
    source: string;
    sourceID: string;
    type: OrganizationMembershipType;
}

export enum OrganizationMembershipType {
    Staff = 0,
    Student = 1,
    Parent = 2,
    Guest = 3,
}

export interface IdentityGroup {
    iD: string;
    name: string;
    type: number;
    source: string;
    sourceID: string;
    organizationID: string;
    groupCustomTypeID: string;
    groupCustomTypeName: string;
    groupCustomTypeSource: string;
    groupCustomTypeSourceID: string;
    description: string;
}
